import type { Option } from '@comparit/core';
import type { VersicherungssummeModus } from '../../../interfaces';

export const versicherungssummeModusOptions: Option<VersicherungssummeModus>[] = [
  { label: 'Automatisch ermitteln (empfohlen)', value: 'auto' },
  { label: 'Eigene Vorgabe', value: 'eigene' },
];
